import { styled } from '@mui/styles';
import * as React from 'react';

export const Wrapper = styled('div')({
  padding: '24px',
});
